import { Component, OnInit, TemplateRef } from '@angular/core';
import { UserModel } from '../models/user.model';
import { CoreService } from '../services/core.service';
import { PrimeNGConfig, SelectItem } from 'primeng/api';
import { SelectItemGroup } from 'primeng/api';

interface Operator {
  name: string,
  code: string
}
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ModalComponent implements OnInit {

  show: boolean = false
  items !: string
  operators !: Operator[];
  countries !: Operator[]

  selectedOperator !: Operator;

  constructor(private coreService: CoreService, private primengConfig: PrimeNGConfig) {
  }

  ngOnInit(): void {
    this.primengConfig.ripple = true
    this.coreService.getOperators(0)
      .subscribe(success => {
        let s = success as any[]
        this.operators = s.map(function (element) {
          return {
            name: element.firstName + ' ' + element.lastName,
            code: element.id
          }
        })
        this.show = true
      })
  }

  operatorChange(event: any) {
  }
}
